<!--Componente para los distribuidores. Podra ver y operar sobre los pedidos realizados por los SubAgentes -->
<!--Componente para los SubAgentes. Donde cada subAgente realiza pedidos a su distribuidor. Puede ver los pedidos realizados -->
<template>
    <div>
    <el-row class="container" style="margin-top:15px;" :gutter="20">
      <!-- Columna Filtros -->
      <el-col class="container_col_1" :span="6">
       <el-row style="margin-bottom:15px;">
          <el-col :span="12">
            <div class="title">{{ $t('NAVBAR_pedidosSubagentes') }}</div>
          </el-col>
          <el-col :span="12" class="btn-nuevo">
              <el-button v-if="filtros.instancia == '4'" class="btnInstancia" type="primary" size="mini" @click="showDialogSeleccionados" round>{{ $t('PEDIDOSUBAGENTE_pasar_a_seleccionados')}}</el-button>
              <el-button v-if="filtros.instancia == '3'" class="btnInstancia" type="primary" size="mini" @click="showDialogHistoricos" round>{{$t('PEDIDOSUBAGENTE_pasar_a_historicos')}}</el-button>

          </el-col>
        </el-row>

        <!-- Busqueda simple -->
        <el-row>
          <el-collapse v-model="activeNames" style="margin-bottom: 5px;">
            <el-collapse-item class="busqueda" :title="$t('GENERAL_Busqueda_Simple')" name="1">
              <div class="filters" > 

                <div class="filters_item">
                  <div class="label">{{$t('PEDIDO_instancia')}}</div>
                    <el-select 
                      class="seleccionador" 
                      v-model="filtros.instancia" 
                      size="small" 
                      @change="getPedidosDelayed"
                      :placeholder="$t('PEDIDOSUBAGENTE_instancia_confirmado')"
                    >
                      <el-option :value='""' :label="$t('GENERAL_OPCION_TODOS')"></el-option>
                      <el-option :value="'4'" :label="$t('PEDIDOSUBAGENTE_instancia_confirmado')"></el-option>
                      <el-option :value="'3'" :label="$t('PEDIDOSUBAGENTE_instancia_seleccionado')"></el-option>
                      <el-option :value="'2'" :label="$t('PEDIDOSUBAGENTE_instancia_historico')"></el-option>
                  </el-select>
                </div>

                <div class="filters_item">
                  <div class="label">{{ $t('PEDIDO_numero') }}</div>
                  <el-input
                    :placeholder="$t('PEDIDO_numero_placeholder')"
                    size="small"
                    v-model="filtros.numero"
                    @input="getPedidosDelayed"
                  />
                </div>
              

              <div v-show="!showDateOptions">
                  <div class="filters_item">
                  <el-row style="text-align:left;">
                    <el-col :span="2">
                      <el-checkbox                                       
                        v-model="filtros.checkPeriodo"
                        size="medium"
                        @change="changeCheck('P')"
                        >
                      </el-checkbox>
                    </el-col>

                    <el-col :span="20" style="text-align:left !important;">
                      <el-dropdown trigger="click" @command="changePeriodo">
                        <span
                          :class="{'el-dropdown-link': filtros.checkPeriodo, 'el-dropdown-link-active': !filtros.checkPeriodo}"
                        >
                          {{this.$t(filtros.periodo)}}
                          <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="PEDIDO_periodo_meses_1" :disabled="filtros.checkRango">{{$t('PEDIDO_periodo_meses_1')}}</el-dropdown-item>
                          <el-dropdown-item command="PEDIDO_periodo_meses_2" :disabled="filtros.checkRango">{{$t('PEDIDO_periodo_meses_2')}}</el-dropdown-item>
                          <el-dropdown-item command="PEDIDO_periodo_meses_3" :disabled="filtros.checkRango">{{$t('PEDIDO_periodo_meses_3')}}</el-dropdown-item>
                          <el-dropdown-item command="PEDIDO_periodo_ultimos_2años" :disabled="filtros.checkRango">{{$t('PEDIDO_periodo_ultimos_2años')}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-col>
                  </el-row>
                </div>

                <div class="filters_item">
                  <el-row style="text-align:left; vertical-align:top;">
                    <el-col :span="2">
                      <el-checkbox
                        v-model="filtros.checkRango"
                        size="medium"
                        @change="changeCheck('R')"
                        >              
                      </el-checkbox>
                    </el-col>
                    <el-col :span="20">
                      <div class="label" style="padding-top:3px !important;">{{$t('GENERAL_desde')}}</div>
                      <el-date-picker
                        style="width:90%"
                        v-model="filtros.from"
                        type="date"
                        size="small"
                        format="dd/MM/yyyy"
                        suffix-icon="el-icon-date"
                        placeholder="dd/mm/aaaa"
                        @input="getPedidosDelayed"
                        @change="getPedidosDelayed"
                        :picker-options="pickerOptionsFrom"
                        :disabled="filtros.checkPeriodo"
                      />

                      <div class="label">{{$t('GENERAL_hasta')}}</div>
                      <el-date-picker
                        v-model="filtros.to"
                        style="width:90%"
                        type="date"
                        size="small"
                        format="dd/MM/yyyy"
                        suffix-icon="el-icon-date"
                        placeholder="dd/mm/aaaa"
                        @input="getPedidosDelayed"
                        @change="getPedidosDelayed"
                        :picker-options="pickerOptionsTo"
                        :disabled="filtros.checkPeriodo"
                      />
                    </el-col>
                  </el-row>
                </div>
              </div>

              <div class="clearFilters" @click="cleanFilters">{{$t('GENERAL_clean_filters')}}</div>
              </div>
            </el-collapse-item>

            <el-collapse-item  v-if="filtros.instancia == '3'" class="busqueda" :title="$t('PEDIDOSUBAGENTE_exportar')" name="2">
              <el-button class="btnExportarConsolidado1" 
              type="primary" size="small" 
              @click="exportExcelConsolidado" round
              >
                {{ $t('PEDIDOSUBAGENTE_exportar_excel_consolidado')}}
                <i class="el-icon-notebook-1" v-if="!estaDescargando_excelConsolidado"></i>
                <i v-else class="el-icon-loading "></i>
              </el-button>

              <el-button class="btnExportarConsolidado2" 
              type="primary" size="small" 
              @click="exportExcelDetalles" round
              >
                {{ $t('PEDIDOSUBAGENTE_exportar_excel_detalles')}}
                <i class="el-icon-notebook-2" v-if="!estaDescargando_excelDetalles"></i>
                <i v-else class="el-icon-loading "></i>
              </el-button>
            </el-collapse-item>
          </el-collapse>
        </el-row>
      </el-col>

      <!-- Resultados de búsqueda --> 
      <el-col class="container_col_2" :span="17">
        <!-- Header resultados de búsqueda -->
        <el-row style="margin-bottom:3px;">
          <el-col :xs="8" :sm="12"  :md="10" :lg="16" :xl="16">
             <div class="sub-title">{{$t('GENERAL_resultado')}}</div>
          </el-col>
          <el-col :xs="16" :sm="12"  :md="14" :lg="8" :xl="8" class="pagination_container">
            <el-pagination         
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              @current-change="handlePageChange"
              hide-on-single-page
              :pager-count="5"
            ></el-pagination>
          </el-col>
        </el-row>
        <el-row style="text-align: left;" class="SinConfirmar">
          <el-col :xs="16" :sm="16"  :md="17" :lg="19" :xl="16">
              {{$t('PEDIDO_sin_confirmar')}}: {{ pedidosSinConfirmar }}
          </el-col>
          <el-col :xs="8" :sm="8"  :md="7" :lg="5" :xl="8" class="checkTodos">
              <el-checkbox v-model="checkedPedidos">{{$t("PEDIDOSUBAGENTE_seleccione_todos")}}</el-checkbox>
          </el-col>
        </el-row>

        <!-- Pedidos -->
        <el-row>
            <div class="card_list">
            <div v-if="loading" v-loading.lock="loading" class="loader"></div>
            <div v-else-if="pedidos !== undefined && pedidos.length > 0" class="card_list_item" v-for="pedido in pedidos" :key="pedido.Id">
              <PedidoCard 
                :pedido="pedido" 
                :pantallaOrigen="pantallaOrigen"
                @selectPedido="selectPedido"
                @editar="editarPedido"
                @detalle="detallePedido"
                @eliminar="eliminarPedido"
              />
            </div>
            <div v-else class="loader">{{$t('GENERAL_no_data')}}</div>
          </div>
        </el-row>
      </el-col>
    </el-row>
    
    <!-- Paginador abajo -->
    <el-row style="margin-top:10px; margin-right:20px; text-align: right;">
      <el-col :span="23">
        <el-pagination         
          background
          small
          layout="prev, pager, next"
          :current-page="paginador.page"
          :page-count="paginador.nro_pages"
          :page-size="paginador.pageSize"
          @current-change="handlePageChange"
          hide-on-single-page
        ></el-pagination>
      </el-col>
    </el-row>

    <Dialog 
      :visible="eliminar_pedido"
      :title="$t('PEDIDO_eliminar')"
      :message="eliminar_pedido_msg"
      :onClose="onCloseEliminarConfirmation"
    />

    <Dialog 
      :visible="DialogSeleccionados"
      :title="$t('PEDIDOSUBAGENTE_pasar_a_seleccionados')"
      :message="pedidosSeleccionados_msg"
      :onClose="onClosePasarASeleccionadosConfirmation"
    />

    <Dialog 
      :visible="DialogHistoricos"
      :title="$t('PEDIDOSUBAGENTE_pasar_a_historicos')"
      :message="pedidosHistoricos_msg"
      :onClose="onClosePasarAHistoricosConfirmation"
    />


  </div>
</template>

<script>
  import PedidoCard from "@/components/Cards/pedidoCard";
  import { mapState } from "vuex";
  import i18n from "../../plugins/i18n";
  import Dialog from "../Dialog";
  import { showError, showSuccess } from "../Mensaje";

  let defaultPaginador = {
    page: 1,
    nro_pages: 1,
    pageSize: 20
  };

  let defaultFilters = {
      instancia: '4',
      numero: "",
      from: undefined,
      to: undefined,
      periodo: "PEDIDO_periodo_meses_1",
      tipo_filtro: "PEDIDO_periodo",
      ordenar: "",
      checkPeriodo: true,
      checkRango: false
  };

    export default {
        name: "PedidosSubAgentes",
        components: { PedidoCard, Dialog},

        data() {
      return {
        pedido: undefined,
        pedidos: [],
        paginador: { ...defaultPaginador },
        filtros: { ...defaultFilters },
        activeNames: ["1"],
        loading: false,
        opened: false,
        pickerOptionsFrom: {
          disabledDate: this.disabledDateFrom
        },
        pickerOptionsTo: {
          disabledDate: this.disabledDateTo
        },
        pedidosSinConfirmar: 0,
        eliminar_pedido_msg: "",
        eliminar_pedido: false,
        pedido_id: undefined,
        pantallaOrigen: 'PedidoSubagente',
        arrayIdPedidos: [],
        DialogSeleccionados: false,
        DialogHistoricos: false,
        pedidosSeleccionados_msg: "",
        pedidosHistoricos_msg: "",
        checkedPedidos: false,
        descargando_excelConsolidado: false,
        descargando_excelDetalles: false,
        checkedPedidos: false,
      };
    },
    computed: {
      ...mapState({
        idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
        ultimoFiltroAplicado: state => state.pedidosSubagentes.filtrosPedido
      }),
      showDateOptions: function(){
        if(this.filtros.instancia == '1'){
          return true;
        }else{
          return false;
        }
      },
      estaDescargando_excelConsolidado()
      {
        return this.descargando_excelConsolidado;
      },
      estaDescargando_excelDetalles()
      {
        return this.descargando_excelDetalles;
      },

    },
    watch: {
      checkedPedidos: function(){
        //this.checkedPedidos = !this.checkedPedidos;
        if(this.checkedPedidos == true){
          for(var i = 0; i<this.pedidos.length; i++){
            this.pedidos[i].Seleccionado = true;
          }
        }else{
          for(var i = 0; i<this.pedidos.length; i++){
            this.pedidos[i].Seleccionado = false;
          }
        }
      }
    },
    methods: {
      
      //Funciones que abren el Dialog para confirmar el pasaje de instancias
      showDialogSeleccionados(){
        this.pedidosSeleccionados_msg = this.$t('PEDIDOSUBAGENTE_pasar_a_seleccionados_msg');
        this.DialogSeleccionados = !this.DialogSeleccionados;
        
      },
      showDialogHistoricos(){
        this.pedidosHistoricos_msg = this.$t('PEDIDOSUBAGENTE_pasar_a_historicos_msg');
        this.DialogHistoricos = !this.DialogHistoricos;
      },

      //Funciones que se lanzan cuando el dialog de cambio de instancia es confirmado
      onClosePasarASeleccionadosConfirmation(confirm){

        if(confirm){
          this.onPasarASeleccionados();
        }

        this.pedidosSeleccionados_msg = "";
        this.DialogSeleccionados = false;
        this.arrayIdPedidos = [];
        this.checkedPedidos = false;
      },

      onClosePasarAHistoricosConfirmation(confirm){
        if(confirm){
          this.onPasarAHistoricos();
        }

        this.pedidosHistoricos_msg = "";
        this.DialogHistoricos = false;
        this.arrayIdPedidos = [];
        this.checkedPedidos = false;
      },
      //Funciones que se comunican con el back pasandole un id de los pedidos seleccionados
      onPasarASeleccionados(){
        for(var i = 0; i<this.pedidos.length; i++){
          if(this.pedidos[i].Seleccionado == true){
            this.arrayIdPedidos.push(this.pedidos[i].Id);
          }
        }

      if (this.arrayIdPedidos.length === 0) {
        showError(this.$t("PEDIDOSUBAGENTE_seleccione_pedido"));
        return;
      }

        let payload = {
          PedidosId: this.arrayIdPedidos,
        };

        this.$store.dispatch('pedidosSubagentes/seleccionarPedidos', payload)
          .then(result => {
            if (result.CodigoResultado != 0)  mostrarMensajeInternacionalizado(
                result.CodigoResultado,
                result.DescripcionResultado
              );
            else showSuccess(this.$t("GENERAL_success"));
          })
          .finally(() => (this.getPedidos()));
      },

      onPasarAHistoricos(){
        for(var i = 0; i<this.pedidos.length; i++){
          if(this.pedidos[i].Seleccionado == true){
            this.arrayIdPedidos.push(this.pedidos[i].Id);
          }
        }
        if (this.arrayIdPedidos.length === 0) {
        showError(this.$t("PEDIDOSUBAGENTE_seleccione_pedido"));
        return;
        }

        let payload = {
          PedidosId: this.arrayIdPedidos,
        };
        this.$store.dispatch('pedidosSubagentes/pasarAHistorico', payload)
          .then(result => {
            if (result.CodigoResultado != 0)  mostrarMensajeInternacionalizado(
                result.CodigoResultado,
                result.DescripcionResultado
              );
            else showSuccess(this.$t("GENERAL_success"));
          })
          .finally(() => (this.getPedidos()));

          this.arrayIdPedidos = [];
      },
      //funciones que descarga un excel con todos los pedidos seleccionados
      exportExcelConsolidado(){
        this.descargando_excelConsolidado = true;
        let idioma = i18n.locale;
        let index = Math.floor(Math.random() * (9999 - 1) + 1);

        for(var i = 0; i<this.pedidos.length; i++){
          if(this.pedidos[i].Seleccionado == true){
            this.arrayIdPedidos.push(this.pedidos[i].Id);
          }
        }
        if (this.arrayIdPedidos.length === 0) {
        showError(this.$t("PEDIDOSUBAGENTE_seleccione_pedido"));
        this.descargando_excelConsolidado = false;
        return;
      }
        
        let payload = {
          PedidosId: this.arrayIdPedidos,
          IdUsuario: this.idUsuario,
          Idioma: idioma
        };

        this.$store.dispatch('pedidosSubagentes/exportarConsolidados', payload)
          .then(response =>
        {
          let link = document.createElement('a')
          link.href = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" + ";base64," + encodeURIComponent(response.Datos)
          link.target = '_blank';
          console.log(link.href);
          link.setAttribute('download', this.$t('PEDIDOSUBAGENTE_pedido_consolidados') +"_" + index + ".xlsx");
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .finally(() => this.descargando_excelConsolidado = false);

          this.arrayIdPedidos = [];
      },
      exportExcelDetalles(){
        this.descargando_excelDetalles = true;
        let idioma = i18n.locale;
        let index = Math.floor(Math.random() * (9999 - 1) + 1);

        for(var i = 0; i<this.pedidos.length; i++){
          if(this.pedidos[i].Seleccionado == true){
            this.arrayIdPedidos.push(this.pedidos[i].Id);
          }
        }
        if (this.arrayIdPedidos.length === 0) {
        showError(this.$t("PEDIDOSUBAGENTE_seleccione_pedido"));
        this.descargando_excelDetalles = false;
        return;
      }
        
        let payload = {
          PedidosId: this.arrayIdPedidos,
          IdUsuario: this.idUsuario,
          Idioma: idioma
        };

        this.$store.dispatch("pedidosSubagentes/exportarDetallesPedidos", payload)
          .then(response =>
        {
          let link = document.createElement('a')
          link.href = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" + ";base64," + encodeURIComponent(response.Datos)
          link.target = '_blank';
          console.log(link.href);
          link.setAttribute('download', this.$t('PEDIDOSUBAGENTE_pedido_detalles') +"_" + index + ".xlsx");
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .finally(() => {
            this.descargando_excelDetalles = false;
            this.showDialogHistoricos();
            //this.getPedidos(); 
          });

          
          //this.arrayIdPedidos = [];
      },

      selectPedido(id_ped) {
        let pedido = this.pedidos.filter(pedidoAux => pedidoAux.Id == id_ped)
        pedido.Seleccionado = !pedido.Seleccionado
      },

      changeCheck(check)
      {
        if(check =='P')
        {
          this.filtros.checkRango = this.filtros.checkPeriodo == true? false : true;
          this.filtros.tipo_filtro = "PEDIDO_periodo";
        }
        else
        { 
          this.filtros.checkPeriodo =this.filtros.checkRango == true? false:true;
          this.filtros.tipo_filtro = "PEDIDO_rango";
        }

        this.getPedidos()
      },

      disabledDateFrom(time) 
      {
        if (this.filtros.to !== "") 
          return time.getTime() > this.filtros.to;
        
        else 
          return false;
      },

      disabledDateTo(time) 
      {
        if (this.filtros.from !== "") 
          return time.getTime() < this.filtros.from;
        
        else 
          return false;
      },

      handlePageChange(page) 
      {
        this.paginador.page = page;
        this.getPedidos();
      },

      getPedidos() 
      {
        
        // armo el payload
        let payload = { }
        payload.idUsuario = this.idUsuario
        payload.instancia = this.filtros.instancia
        payload.numero = this.filtros.numero

        if (this.filtros.tipo_filtro !== "PEDIDO_periodo") 
        {
          if(payload.instancia == '1'){
            payload.desde = null;
            payload.hasta = null;
          }else{
            payload.desde = this.filtros.from;
            payload.hasta = this.filtros.to;

            if(!payload.desde && !payload.hasta)
              return
          }
          
        } 
        else 
        {
          payload.mesesADesfazar = this.mapPeriodoToMeses();
        }

        payload.page = this.paginador.page
        payload.pageSize = this.paginador.pageSize


        // indico que se están buscando los pedidos
        this.loading = true;
        // guardo los filtros aplicados
        this.$store.dispatch('pedidosSubagentes/setFiltrosPedido', { ...this.filtros })
        //this.$store.dispatch('pedidos/setFiltrosPedido', { ...this.filtros })
        // busco los pedidos
        this.$store.dispatch('pedidosSubagentes/getPedidos', payload)
        //this.$store.dispatch('pedidos/getPedidos', payload)
        .then(data => 
        {
          if(data.CodigoResultado == 0) 
          {
            var paginado = JSON.parse(data.Datos)
            //this.pedidos = paginado.Result;
            this.paginador.nro_pages = paginado.TotalPages;


            let pedidos = paginado.Result;
            pedidos.map(ped => {
              ped.Seleccionado = false;
            });
            this.pedidos = pedidos


            //console.log(paginado);

            if(payload.instancia == '1'){
              this.pedidosSinConfirmar = paginado.TotalObjects;
            }

          }
        })
        .finally(() => {
          this.loading = false;
        })
      },

      getPedidosDelayed() 
      {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }

        this.timer = setTimeout(() => {
          this.paginador = { ...defaultPaginador };
          this.getPedidos();
        }, 1000);
      },

      changePeriodo(periodo) 
      {
        
        this.filtros.periodo = periodo;
        this.getPedidos();
      },

      cleanFilters() 
      {
        // limpio los filtros
        this.filtros = { ...defaultFilters };
        this.paginador = { ...defaultPaginador };

        // limpio los resultados de pedidos
        this.pedidos = [];

        this.getPedidos();
      },

      toggleOpen() 
      {
        this.opened = !this.opened      
      },

      mapPeriodoToMeses() 
      {
        if(this.filtros.instancia == '1'){
          return null;
        }else{
          switch (this.filtros.periodo) 
          {
            case "PEDIDO_periodo_meses_1":
              return -1;
            case "PEDIDO_periodo_meses_2":
              return -2;
            case "PEDIDO_periodo_meses_3":
              return -3;
            case "PEDIDO_periodo_ultimos_2años":
              return -24;
            default:
              return 1;
          }
      }

      },

      editarPedido(id)
      {
        // this.$router.push({ path: `/pedidos/edicion/${id}`});
        this.$router.push({ name: 'Edicion Pedido Subagente', params: {id}});
      },

      detallePedido(id)
      {
        // this.$router.push({ path: `/pedidos/detalle/${id}`});
        this.$router.push({ name: 'Detalle Pedido Subagente', params:{id}});
      },

      eliminarPedido(id){
        this.eliminar_pedido_msg = this.$t('PEDIDO_eliminar_mensaje');
        this.eliminar_pedido = true;
        this.pedido_id = id;
      },

      onCloseEliminarConfirmation(confirm){

        if(confirm){
          this.deletePedido(this.pedido_id);
        }

        this.eliminar_pedido_msg = "";
        this.eliminar_pedido = false;
        this.pedido_id = undefined;
      },

      deletePedido(id){
        let payload = { }
        payload.idUsuario = this.idUsuario
        payload.id = id

        this.$store.dispatch("pedidosSubagentes/eliminarPedido", payload)
       //this.$store.dispatch("pedidos/eliminarPedido", payload)
          .then(result => {
            if (result.CodigoResultado != 0)  mostrarMensajeInternacionalizado(
                result.CodigoResultado,
                result.DescripcionResultado
              );
            else showSuccess(this.$t("GENERAL_success"));
          })
          .finally(() => (this.getPedidos()));

      },

      clearDesdeHasta(){
        this.filtros.from = null;
        this.filtros.to = null;
      }
    },
    
    mounted() 
    {
      //Scroll para Android
       document.body.scrollTop = 0;
       //Scroll para IOS
       document.documentElement.scrollTop = 0;
      // verifico si se pasó un número de pedido como parámetro
      if(this.$route.params.numeroPedido !== undefined)
      {
        this.filtros.numero = this.$route.params.numeroPedido;
        this.filtros.instancia = '4';
      }

      // verifico si se deben mantener los últimos filtros aplicados
      if (this.$route.params.keepFilter === true)
        this.filtros = { ...this.ultimoFiltroAplicado };

      // busco los pedidos
      this.getPedidos();
    }
    }
</script>

<style scoped>
.greyLabel {
  color: #6B6B6B;
  font-weight: normal;
}
.btnInstancia{
  font-size:10px !important;
}
.btnExportarConsolidado1{
  margin-top: 5px;
  font-size:14px !important;
  width: 90%;
}

.btnExportarConsolidado2{
  margin-top: 5px;
  font-size:14px !important;
  width: 90%;
  margin-left: 0px;
}
.checkTodos{
  text-align: right;
}
.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}

.label {
  text-align: left;
  margin-bottom: 4px;
  font-size: 14px;
}

.seleccionador {
    width: 100%;
    padding: 0;
}

.btn-nuevo {
  padding-right:0%;
  text-align:right;
}
.el-card {
  height: 100%;
}
.cardBody {
  padding-left: 25px;
}

.container {
  display: flex;
  min-height: 500px !important;
  width:  100% !important;
}

.pagination_container {
  text-align: right;
  padding-right:0px;
}

@media (max-width: 900px) {
  .busqueda {
  font-size: 10px;
  }
}

@media (max-width: 600px) {
  .container {
    flex-direction: column;
  }
  .container_col_1 {
    flex: 1;
    width:100% !important;
  }
  .container_col_2 {
    flex: 1;
    width:100% !important;
    margin-top:20px;
  }
  .busqueda {
  font-size: 14px;
  }
}

.card {
  width: 100%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.10);
  justify-self: center;
}

.card_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 1rem;
}
.card_list_item {
  position: relative;
}

.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
}
.sub-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #999;
}
.filters {
  display: flex;
  flex-direction: column;
}
.filters_item {
  flex: 1;
  margin-bottom: 10px;
}


.clearFilters {
  color: #5aabc6;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  cursor: pointer;
}

.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 0.1s;   
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.soonToExpire {
  font-size: 14px;
  color: #2e2e2e;
  font-weight: bold;
  text-align: left;
  margin-top: 40px;
}
.el-radio-group {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 14px;
}
.el-radio {
  line-height: 2;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.loader {
  margin-top: 25%;
  color: #999;
}
.ordena{
  text-align: right;
  margin-bottom: 20px;
}

.SinConfirmar{
  color: rgba(0, 0, 0, 0.644);
  font-size: 12px;
  margin-top: 0px;
  margin-bottom: 10px;
}
</style>

<style>
.ordenar .el-input__inner{
  border: none;
  width: 70%;
}
.el-icon-arrow-up:before{
  color:#409EFF;
  font-weight: bold;
}
.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}
.greyLabel {
  font-size: 14px;
  color: #6b6b6b;
  text-align: left;
  font-weight: normal;
}

</style>
